import { number } from 'prop-types';
import { create } from 'zustand';

type VhcRecordStoreState = {
  brunch?: number;
};
type WaitingStore = {
  state?: VhcRecordStoreState;
  setState: (newState?: VhcRecordStoreState) => void;
  setBranch: (brunch?: number) => void;
};

export const useVhcRecordStoreStore = create<WaitingStore>((set, get) => ({
  setState: (newState) => set({ state: newState }),
  setBranch: (brunch) =>
    set((prevState) => {
      return { state: { ...prevState, brunch: brunch } };
    })
}));
